import axios from "axios";
import React, { useEffect, useState } from "react";
import { translate } from "reducers/i18n";
import "./emailAccessCode.css";
import settings from "client.settings.json";
import { PageComponent } from "components/page";
let errorDurationLength = 10000;

const EmailAccessCode = (props) => {
  const { setError, messageId, authenticators, mappings, email } = props;

  const [codeRequested, setCodeRequested] = useState(null);
  const [codeValidated, setCodeValidated] = useState(null);

  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(null);
  const [showDoubleClickError, setShowDoubleClickError] = useState(false);
  const [coolingDown, setCoolingDown] = useState(false);
  const [count, setCount] = useState(15);

  useEffect(() => {
    if (!coolingDown) return;
    setCount(15);
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setCoolingDown(false);
          setCodeError(null);
          return null;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [coolingDown]);

  const placeholder =
    mappings["E_DELIVERY_ENTER_CODE_PAGE_EMAIL"]?.placeholder?.replace(
      /<\/?[^>]+(>|$)/g,
      "",
    ) || "";

  const requestCode = async () => {
    if (showDoubleClickError === true) {
      setCoolingDown(true);
      setCodeError("_error_resend_code");
    } else {
      setCodeRequested("requesting");
      try {
        await axios({
          url: settings.api + "/api/login/requestcode",
          method: "post",
          data: {
            messageId,
            authenticatorId: authenticators.find(
              (a) => a?.type === "emailAccessCode",
            )?._id,
          },
        });
        setCodeRequested("requested");
      } catch (e) {
        setError(e.message);
      }
    }
  };

  const validateCode = async () => {
    setCodeValidated("validating");
    setCodeError(null);
    try {
      await axios({
        url: settings.api + "/api/login/validatecode",
        method: "post",
        data: {
          messageId,
          code: code,
        },
      });
    } catch (e) {
      setCodeValidated(null);
      setCodeError(e.response?.data?.errorcode || e.message);
      if (e.status === 429) setCoolingDown(true);
    }
  };

  const btnFunctions = {
    E_DELIVERY_LOGIN_PAGE_EMAIL: [() => requestCode()],
    E_DELIVERY_ENTER_CODE_PAGE_EMAIL: [
      () => validateCode(),
      () => {
        setShowDoubleClickError(true);
        setTimeout(() => {
          setShowDoubleClickError(false);
        }, errorDurationLength);
        requestCode();
      },
    ],
  };

  const snippets = {
    "recipient email": email || "",
  };

  return (
    <>
      {(codeRequested === "requested" || codeRequested === "requesting") && (
        <>
          <PageComponent
            noHeader={true}
            content={mappings["E_DELIVERY_ENTER_CODE_PAGE_EMAIL"]}
            snippets={snippets}
            btnFunctions={btnFunctions["E_DELIVERY_ENTER_CODE_PAGE_EMAIL"]}
            disabled={!!codeValidated || coolingDown}
            disabledArray={[!code, false]}
          >
            <p>
              <input
                className="code"
                autoFocus={true}
                type="text"
                inputMode="numeric"
                enterkeyhint={translate("_submit")}
                key="code"
                placeholder={placeholder}
                onChange={(e) => setCode(e.target.value)}
                onKeyPress={(e) => {
                  if (!codeValidated && e.key === "Enter") validateCode();
                }}
                {...(codeError
                  ? {
                      "aria-invalid": true,
                      "aria-describedby": "codeError",
                    }
                  : {})}
              />
              {coolingDown ? (
                <span className="CodeError" id="codeError">
                  {translate(codeError, count)}
                </span>
              ) : (
                codeError && (
                  <span className="CodeError" id="codeError">
                    {translate(codeError)}
                  </span>
                )
              )}
            </p>
          </PageComponent>
        </>
      )}
      {codeRequested !== "requested" && codeRequested !== "requesting" && (
        <>
          <PageComponent
            noHeader={true}
            content={mappings["E_DELIVERY_LOGIN_PAGE_EMAIL"]}
            snippets={snippets}
            btnFunctions={btnFunctions["E_DELIVERY_LOGIN_PAGE_EMAIL"]}
            disabled={!!codeValidated}
          />
        </>
      )}
    </>
  );
};

export default EmailAccessCode;
